import { SparklesIcon } from "@heroicons/react/16/solid";
import { ReactElement } from "react";

import { FloatingAIFormPanel } from "./floating/FloatingAIFormPanel.tsx";

export interface LiquidTemplateAiButtonProps {
  jsonContext: string;
  onError?: (errorMessage: string) => void;
  onSuccess: (template: string) => void;
}

const TRIGGER_CLASSNAME =
  "mt-1 size-8 min-w-0 rounded p-0 text-zinc-500 hover:bg-zinc-200 hover:text-zinc-700 disabled:opacity-50 dark:hover:bg-zinc-600 dark:hover:text-zinc-200 [&>[data-slot=icon]]:size-4";

/**
 * AI button for entity mapping: opens a floating panel to describe desired data,
 * then calls the Liquid template generation endpoint.
 */
export const LiquidTemplateAiButton = ({
  jsonContext,
  onError,
  onSuccess,
}: LiquidTemplateAiButtonProps): ReactElement => (
  <FloatingAIFormPanel
    jsonContext={jsonContext}
    loadingMessage="Generating template…"
    onError={onError}
    onSuccess={onSuccess}
    placeholder="Describe the data you would like to extract"
    tooltipContent="Generate with AI"
    trigger={<SparklesIcon aria-hidden data-slot="icon" />}
    triggerAriaLabel="Describe data to extract with AI"
    triggerClassName={TRIGGER_CLASSNAME}
  />
);
